'use client';

import { c as _c } from "react/compiler-runtime";
import { useParseSearchParams } from '@repo/sdk/qs';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
export const useTableFilters = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [filters, setFilters] = useState(t0);
  const {
    parsedParams,
    searchParams
  } = useParseSearchParams();
  let t1;
  if ($[1] !== parsedParams.filter) {
    t1 = () => {
      if (parsedParams?.filter) {
        setFilters(Object.entries(parsedParams.filter).map(_temp));
      }
    };
    $[1] = parsedParams.filter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  const router = useRouter();
  const pathname = usePathname();
  let t3;
  if ($[4] !== filters || $[5] !== parsedParams.filter || $[6] !== pathname || $[7] !== router || $[8] !== searchParams) {
    t3 = () => {
      const params = new URLSearchParams(searchParams);
      filters.forEach(filter => {
        params.set(`filter[${filter.id}]`, `${filter.value}`);
      });
      const filtersToRemove = parsedParams.filter ? Object.keys(parsedParams.filter).filter(key_0 => !filters.some(filter_0 => filter_0.id === key_0)) : [];
      filtersToRemove.forEach(filter_1 => {
        params.delete(`filter[${filter_1}]`);
      });
      router.replace(`${pathname}?${params.toString()}`);
    };
    $[4] = filters;
    $[5] = parsedParams.filter;
    $[6] = pathname;
    $[7] = router;
    $[8] = searchParams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== filters) {
    t4 = [filters];
    $[10] = filters;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== filters) {
    t5 = {
      filters,
      setFilters
    };
    $[12] = filters;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(t0) {
  const [key, value] = t0;
  return {
    id: key,
    value
  };
}